import { z } from 'zod';

const semverRegex = /^\d+\.\d+\.\d+$/;

export const updateAppVersionSchema = z
  .object({
    ios_version: z.string().regex(semverRegex).optional(),
    android_version: z.string().regex(semverRegex).optional(),
    ios_store_url: z.union([z.string().url(), z.literal('')]).optional(),
    android_store_url: z.union([z.string().url(), z.literal('')]).optional(),
  })
  .refine((obj) => Object.keys(obj).length > 0, {
    message: 'At least one field is required',
  });

export type UpdateAppVersionPayload = z.infer<typeof updateAppVersionSchema>;
